var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-row",
                { staticClass: "mb-2" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("div", { staticClass: "card card-separator mb-2" }, [
                      _c(
                        "div",
                        { staticClass: "card-header px-3 py-2 bb-0" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex flex-row justify-content-between align-items-center",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c("b-skeleton", {
                                    attrs: { width: "90%", height: "2rem" },
                                  }),
                                  _vm._v(" "),
                                  _c("b-skeleton", { attrs: { width: "5%" } }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-2" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("div", { staticClass: "card card-separator mb-2" }, [
                      _c(
                        "div",
                        { staticClass: "card-header px-3 py-2 bb-0" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex flex-row justify-content-between align-items-center",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c("b-skeleton", {
                                    attrs: { width: "90%", height: "2rem" },
                                  }),
                                  _vm._v(" "),
                                  _c("b-skeleton", { attrs: { width: "5%" } }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-2" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("div", { staticClass: "card card-separator mb-2" }, [
                      _c(
                        "div",
                        { staticClass: "card-header px-3 py-2" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex flex-row justify-content-between align-items-center",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c("b-skeleton", {
                                    attrs: { width: "90%", height: "2rem" },
                                  }),
                                  _vm._v(" "),
                                  _c("b-skeleton", { attrs: { width: "5%" } }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "p",
              {
                staticClass: "mb-0 text-justify",
                staticStyle: { "white-space": "normal" },
              },
              [_c("b-skeleton", { attrs: { height: "4rem" } })],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }